var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Container, SimpleGrid } from '@mantine/core';
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, TouchSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, rectSortingStrategy, } from '@dnd-kit/sortable';
import WordCard from "./WordCard";
import AddNewWordCard from "./AddNewWordCard";
import { useNavigate, useParams } from "react-router";
import WordCardDeleteModal from "./WordCardDeleteModal";
export function WordCardList(_a) {
    var child = _a.child;
    var params = useParams();
    var navigate = useNavigate();
    var _b = useState(child.speechItems.reverse()), cards = _b[0], setCards = _b[1];
    var _c = useState(null), editingCardId = _c[0], setEditingCardId = _c[1];
    var _d = useState(null), removingCard = _d[0], setRemovingCard = _d[1];
    var sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }), useSensor(TouchSensor, { activationConstraint: { delay: 150, tolerance: 5 } }), useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }));
    var handleDragEnd = function (event) {
        var active = event.active, over = event.over;
        if (over && active.id !== over.id) {
            setCards(function (items) {
                var oldIndex = items.findIndex(function (item) { return item.uuid === active.id; });
                var newIndex = items.findIndex(function (item) { return item.uuid === over.id; });
                fetch('/api/speech-item/' + active.id + '/move', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        index: cards.length - 1 - newIndex
                    })
                });
                return arrayMove(items, oldIndex, newIndex);
            });
        }
    };
    var handleAddCard = function () {
        var newCard = {
            uuid: '',
            word: '',
            pronunciation: ''
        };
        setCards(__spreadArray([newCard], cards, true));
        setEditingCardId('');
    };
    var handleRemoveCard = function (uuid) {
        setCards(function (prev) { return prev.filter(function (card) { return card.uuid !== uuid; }); });
    };
    var handleStartEdit = function (uuid) {
        setEditingCardId(uuid);
    };
    var handleSaveEdit = function (cardData) {
        var newCards = [];
        for (var i = 0; i < cards.length; i++) {
            if (cards[i].uuid === '' || cards[i].uuid === cardData.uuid) {
                newCards.push(cardData);
                continue;
            }
            newCards.push(cards[i]);
        }
        setCards(newCards);
        setEditingCardId(null);
    };
    var handleCancelEdit = function () {
        if (editingCardId === '') {
            handleRemoveCard('');
        }
        setEditingCardId(null);
    };
    return _jsxs(_Fragment, { children: [_jsx(Container, { size: "lg", py: "xl", children: _jsx(DndContext, { sensors: sensors, collisionDetection: closestCenter, onDragEnd: handleDragEnd, children: _jsx(SortableContext, { items: cards.map(function (c) { return c.uuid; }), strategy: rectSortingStrategy, children: _jsxs(SimpleGrid, { cols: { base: 1, sm: 2, md: 3 }, spacing: "md", children: [_jsx(AddNewWordCard, { editingCardId: editingCardId, onAdd: handleAddCard }), cards.map(function (card) { return (_jsx(WordCard, { card: card, editingCardId: editingCardId, onRemove: setRemovingCard, onStartEdit: handleStartEdit, onSaveEdit: handleSaveEdit, onCancelEdit: handleCancelEdit }, card.uuid)); })] }) }) }) }), _jsx(WordCardDeleteModal, { card: removingCard, show: removingCard !== null, onClose: function () { return setRemovingCard(null); }, onRemove: handleRemoveCard })] });
}
